import { render, staticRenderFns } from "./serviceChangeProduct.vue?vue&type=template&id=ca8cbb6a&scoped=true"
import script from "./serviceChangeProduct.vue?vue&type=script&lang=ts"
export * from "./serviceChangeProduct.vue?vue&type=script&lang=ts"
import style0 from "./serviceChangeProduct.vue?vue&type=style&index=0&id=ca8cbb6a&prod&lang=scss&scoped=true"
import style1 from "./serviceChangeProduct.vue?vue&type=style&index=1&id=ca8cbb6a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca8cbb6a",
  null
  
)

export default component.exports